import { Search } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { OsintConstantineModal } from '@/sections/customerManagement/components/modals/OsintConstantineModal';
import { OsintProvider } from '@/state/OsintContext';

import { OsintResearchTable } from './OsintResearchTable';

export function OsintDashboard() {
  const [isConstantineModalOpen, setIsConstantineModalOpen] = useState(false);

  return (
    <OsintProvider>
      <div className="flex h-full flex-col">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <h3 className="text-chariot-text-primary text-lg font-medium">
              OSINT Research
            </h3>
            <p className="text-chariot-text-secondary text-sm">
              Constantine zero-day research results against open-source
              repositories.
            </p>
          </div>
          <Button
            onClick={() => setIsConstantineModalOpen(true)}
            className="rounded-full"
            size="sm"
            data-testid="osint-constantine-button"
            aria-label="Launch Constantine scan for open-source technology"
          ><Search className="size-4" />Research with Constantine</Button>
        </div>

        <div className="h-full overflow-y-auto">
          <OsintResearchTable
            onResearchClick={() => setIsConstantineModalOpen(true)}
          />
        </div>

        <OsintConstantineModal
          open={isConstantineModalOpen}
          onClose={() => setIsConstantineModalOpen(false)}
        />
      </div>
    </OsintProvider>
  );
}
